import {
  ContactInformationForm,
  ContactInformationFormValues,
} from "@/components/campaign/setup/planning/ContactInformationForm";
import { useStepperSubmitHandlerState } from "@/utils/stepper";
import { createFileRoute } from "@tanstack/react-router";
import { useMemo } from "react";

export const Route = createFileRoute(
  "/_dashboard/campaigns/$id/(edit)/boost/contact-information",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const context = Route.useRouteContext();
  const { campaign } = context.useEditCampaign();
  const stepper = context.useStepper();

  const { leadAmount } = stepper.context;
  if (leadAmount === null) throw null;

  const historyState = context.useHistoryState();

  const defaultValues = useMemo(
    (): ContactInformationFormValues => ({
      deliverContacts: stepper.context.deliverContacts ?? false,
      deliverContactsRequirePhone:
        stepper.context.deliverContactsRequirePhone ?? false,
      deliverLiveNumber: stepper.context.deliverLiveNumber ?? false,
    }),
    [
      stepper.context.deliverContacts,
      stepper.context.deliverContactsRequirePhone,
      stepper.context.deliverLiveNumber,
    ],
  );

  const startCampaignRunMutation = context.useStartCampaignRunMutation();

  const [submitHandler, setSubmitHandler] = useStepperSubmitHandlerState();

  context.stepper.useStepperSubmit(submitHandler);

  return (
    <ContactInformationForm
      configurations={campaign.configurations}
      exportSystem={campaign.exportSystem}
      defaultValues={defaultValues}
      updateValues={async (values) =>
        startCampaignRunMutation.mutateAsync({
          options: {
            amount: leadAmount,
            completionEmail: campaign.completionEmail,
            ...values,
          },
          skipCreditCheck: historyState?.autoSubmit,
        })
      }
      setSubmitHandler={setSubmitHandler}
      linkToContactsFilter={{
        to: "/campaigns/$id/define/$category/contacts",
        params: { category: "contacts" },
      }}
      autoSubmit={historyState?.autoSubmit}
    />
  );
}
